import React, { Fragment, useContext } from "react";

import { Grid, Typography } from "@mui/material";

import LoadingPage from "../../react_utils/LoadingPage";
import InfoTooltip from "../../react_utils/InfoTooltip";
import SgReadyHistoryTable from "./heatpump/SgReadyHistoryTable";
import {
  sgReadyHistoryHelp,
  sgReadyHistoryTitle,
} from "../../shared/constants/sgreadyhistory";
import CustomerLocationClient from "../../shared/api/CustomerLocationClient";
import useSgReadyHistory from "../../shared/hooks/heatpump/useSgReadyHistory";
import { AuthContext } from "../../shared/contexts/AuthContext";
import TablePagination from "../../react_utils/table/TablePagination";

export default function SgReadyHistory() {
  const { apiClient } = useContext(AuthContext);
  const locationClient = new CustomerLocationClient(apiClient);

  const { sgReadyHistory, pagination } = useSgReadyHistory(locationClient);

  if (sgReadyHistory === null) return <LoadingPage />;

  return (
    <Fragment>
      <div className="text-center">
        <Typography sx={{ marginY: "10px" }}>
          {sgReadyHistoryTitle} <InfoTooltip>{sgReadyHistoryHelp}</InfoTooltip>
        </Typography>
      </div>
      <Grid container justify="center">
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          <SgReadyHistoryTable sgReadyHistory={sgReadyHistory} />
        </Grid>
        <Grid xs={12} sm={12} md={12} item paddingTop={"10px"}>
          <TablePagination
            nPages={pagination.nPages}
            page={pagination.page}
            setPage={pagination.setPage}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

SgReadyHistory.propTypes = {};
